// src/services/epoPartialPaymentApi.js
//
// Round 19 — Frontend client for the partial-payment endpoints. Mirrors
// Controllers/EPO/EpoPartialPaymentController.cs route-for-route.
//
// Routes:
//   GET    /api/epo/{n}/partial-payment              → PartialPaymentItem[]
//   GET    /api/epo/{n}/partial-payment/line/{ln}    → PartialPaymentItem[]
//   GET    /api/epo/{n}/partial-payment/total        → { Total: decimal }
//   GET    /api/epo/{n}/partial-payment/total/line/{ln} → { Total: decimal }
//   POST   /api/epo/{n}/partial-payment              body { LineNum, Amount, Note? } → { Id }
//   POST   /api/epo/{n}/partial-payment/{id}/void    → 200 OK
//
// Mutations (POST) require Finance / Babu / IT-Admin (R19 backend gate).
// Reads remain accessible to any authenticated user.
import api from "../api";

const base = (epoNum) => `epo/${epoNum}/partial-payment`;

export async function listPartialPayments(epoNum) {
    const res = await api.get(base(epoNum));
    return res.data;
}

export async function listPartialPaymentsByLine(epoNum, lineNum) {
    const res = await api.get(`${base(epoNum)}/line/${lineNum}`);
    return res.data;
}

export async function getPartialPaymentTotal(epoNum) {
    const res = await api.get(`${base(epoNum)}/total`);
    return res.data;
}

export async function getPartialPaymentTotalByLine(epoNum, lineNum) {
    const res = await api.get(`${base(epoNum)}/total/line/${lineNum}`);
    return res.data;
}

export async function createPartialPayment(epoNum, { lineNum, amount, note }) {
    const res = await api.post(base(epoNum), {
        LineNum: Number(lineNum),
        Amount: Number(amount),
        Note: note ?? "",
    });
    return res.data;
}

export async function voidPartialPayment(epoNum, id) {
    await api.post(`${base(epoNum)}/${id}/void`);
}

// R20 — per-line Paid toggle. Lives here because the UI consumer is the
// partial-payments page; route is `POST /api/Epo/{n}/line/{ln}/paid`.
export async function markLinePaid(epoNum, lineNum, { paid, note }) {
    const res = await api.post(`Epo/${epoNum}/line/${lineNum}/paid`, {
        Paid: !!paid,
        Note: note ?? "",
    });
    return res.data;
}
